import FormLabel from '@mui/material/FormLabel';
import React from 'react';
import { labelStyle } from '../../utils/formStyle';

export const FormInputLabel = React.forwardRef((props, ref) => {
  const { label, isRequired, children, ...rest } = props;
  return (
    <div className='flex items-center gap-1'>
      {label && (
        <FormLabel sx={labelStyle}>
          {label} {isRequired && <span className='text-red-500'>*</span>}
        </FormLabel>
      )}
      {children}
    </div>
  );
});

FormInputLabel.displayName = 'FormInputLabel';
